import {DELETE_FROM_PLAN} from "../constants/constants";

export const deleteFromPlan = (step, index) => {
    return {
        type : DELETE_FROM_PLAN,
        payload : {
            step : step,
            index : index
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/deleteFromPlan.js